module.exports = __webpack_public_path__ + "static/media/timi_k_khanchau.ba262b73.ogg";